var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpvoteFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0029 8.5421L2.05923 8.5421C0.91708 8.5421 -0.00134751 9.46116 -0.00134761 10.6041L-0.00134879 24.1543C-0.00134889 25.2855 0.917078 26.2163 2.05923 26.2163L5.0029 26.2163C6.14505 26.2163 7.06348 25.2855 7.06348 24.1543L7.06348 10.6041C7.06348 9.46116 6.14505 8.5421 5.0029 8.5421Z",
    fill: "#FF892A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7143 9.42617L19.1566 9.42617C19.1566 9.42617 20.0397 7.65875 20.0397 4.71305C20.0397 1.17821 17.3904 -7.35312e-05 16.2129 -7.36341e-05C15.0355 -7.3737e-05 14.4467 0.589066 14.4467 3.53477C14.4467 6.48047 11.7386 8.58959 9.99589 9.7443L9.99589 24.3432C11.8798 25.2151 15.6595 26.5112 21.5116 26.5112L23.3955 26.5112C25.6916 26.5112 27.6462 24.8616 28.0347 22.5993L29.3535 14.9405C29.8481 12.0537 27.6344 9.42617 24.7143 9.42617Z",
    fill: "#FF892A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27C32.3137 27 35 24.3137 35 21C35 17.6863 32.3137 15 29 15C25.6863 15 23 17.6863 23 21C23 24.3137 25.6863 27 29 27Z",
    fill: "#52ACBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1503 22.4355C25.7598 22.8261 25.7598 23.4592 26.1503 23.8498C26.5408 24.2403 27.174 24.2403 27.5645 23.8498L29.0003 22.414L30.436 23.8498C30.8266 24.2403 31.4597 24.2403 31.8502 23.8498C32.2408 23.4592 32.2408 22.8261 31.8502 22.4355L30.4145 20.9998L31.8502 19.564C32.2408 19.1735 32.2408 18.5404 31.8502 18.1498C31.4597 17.7593 30.8266 17.7593 30.436 18.1498L29.0003 19.5856L27.5645 18.1498C27.174 17.7593 26.5408 17.7593 26.1503 18.1498C25.7598 18.5404 25.7598 19.1735 26.1503 19.564L27.5861 20.9998L26.1503 22.4355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvoteFailed);
export default __webpack_public_path__ + "static/media/upvote-failed.d26bc4285336e5c4b0b80d7b50d6e575.svg";
export { ForwardRef as ReactComponent };